export const REGISTER_FAILED = "Une erreur s'est produite. Il n'a pas été possible de créer un compte.";